import { tech1AdapterDefinition } from "./tech1";
import { createTestAdapterDefinition } from "./test";

export const adapterDefinitions = import.meta.env.DEV
  ? [tech1AdapterDefinition, createTestAdapterDefinition()]
  : [tech1AdapterDefinition];

export { tech1AdapterDefinition };
